var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolowUpInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 21.249H34.999C35.1633 21.249 35.2966 21.2491 35.4121 21.251C35.414 21.3666 35.415 21.5003 35.415 21.665V29.999C35.415 31.6057 35.4129 32.6846 35.3047 33.4893C35.2013 34.2578 35.0222 34.5871 34.8047 34.8047C34.5871 35.0222 34.2578 35.2013 33.4893 35.3047C32.6846 35.4129 31.6057 35.415 29.999 35.415H9.99902C8.39199 35.415 7.3126 35.413 6.50781 35.3047C5.73923 35.2013 5.40994 35.0222 5.19238 34.8047C4.9749 34.5871 4.79673 34.2577 4.69336 33.4893C4.58513 32.6846 4.58203 31.6057 4.58203 29.999V21.665C4.58203 21.5003 4.58212 21.3667 4.58398 21.251C4.69978 21.2491 4.83396 21.249 4.99902 21.249ZM9.99902 9.58203H29.999C31.6057 9.58203 32.6846 9.58513 33.4893 9.69336C34.2577 9.79673 34.5871 9.9749 34.8047 10.1924C35.0222 10.4099 35.2013 10.7392 35.3047 11.5078C35.413 12.3126 35.415 13.392 35.415 14.999C35.415 15.1633 35.414 15.2967 35.4121 15.4121C35.2966 15.414 35.1633 15.415 34.999 15.415H4.99902C4.83395 15.415 4.69979 15.414 4.58398 15.4121C4.58213 15.2966 4.58203 15.1633 4.58203 14.999C4.58203 13.392 4.58509 12.3126 4.69336 11.5078C4.79676 10.7393 4.97484 10.4099 5.19238 10.1924C5.40993 9.97484 5.73929 9.79676 6.50781 9.69336C7.3126 9.58509 8.39199 9.58203 9.99902 9.58203Z",
    stroke: "#404040",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 5V10M28.3307 5V10",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolowUpInactive);
export default __webpack_public_path__ + "static/media/folowUpInactive.6f957a3abb5f6a1dc5b0e9be3a3b8baa.svg";
export { ForwardRef as ReactComponent };